import styled from 'styled-components';

export const SlotSelectionPanel = styled.div`
  padding: 0.75rem;
  min-width: 13.75rem;
`;

export const SlotCheckboxList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
`;